'use client'

import { useDirection as useDirectionRadix } from '@radix-ui/react-direction'

export const useDirection = () => {
  const direction = useDirectionRadix()
  return direction
}
